var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wordhomw-wrap"},[_c('div',{staticClass:"v-note-wrapper markdown-body shadow"},[_c('h2',[_c('a',{attrs:{"id":"_0"}}),_vm._v("表格列权限")]),_c('h3',[_c('a',{attrs:{"id":"_2"}}),_vm._v("在前端控制哪些列可见。")]),_c('p',[_vm._v("在后端控制返回的数据")])])])
}]

export { render, staticRenderFns }